// Message单独封装，不在此引入
import { Pagination, Dialog, Dropdown, DropdownItem, Menu, Submenu, MenuItem, Input, Radio, RadioGroup, Checkbox, Switch,
  Select, Option, Button, Table, TableColumn, DatePicker, Popover, Tooltip, MessageBox, Breadcrumb, BreadcrumbItem,
  Form, FormItem, Tabs, TabPane, Tree, Loading, Icon, Upload, Progress, Card,
  Container, Aside, Main, Scrollbar, Autocomplete, Cascader, Slider, Divider} from "element-ui"
const element = {
  install: function(Vue, options) {
    Vue.use(Pagination)
    Vue.use(Dialog)
    Vue.use(Dropdown)
    Vue.use(DropdownItem)
    Vue.use(Menu)
    Vue.use(Submenu)
    Vue.use(MenuItem)
    Vue.use(Input)
    Vue.use(Radio)
    Vue.use(RadioGroup)
    Vue.use(Checkbox)
    Vue.use(Switch)
    Vue.use(Select)
    Vue.use(Option)
    Vue.use(Button)
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(DatePicker)
    Vue.use(Popover)
    Vue.use(Tooltip)
    Vue.use(Breadcrumb)
    Vue.use(BreadcrumbItem)
    Vue.use(Form)
    Vue.use(FormItem)
    Vue.use(Tabs)
    Vue.use(TabPane)
    Vue.use(Tree)
    Vue.use(Icon)
    Vue.use(Upload)
    Vue.use(Progress)
    Vue.use(Card)
    Vue.use(Container)
    Vue.use(Aside)
    Vue.use(Main)
    Vue.use(Autocomplete)
    Vue.use(Cascader)
    Vue.use(Scrollbar)
    Vue.use(Slider)
    Vue.use(Divider)
    Vue.use(Loading.directive)
    Vue.prototype.$loading = Loading.service
    Vue.prototype.$alert = MessageBox.alert
    Vue.prototype.$msgbox = MessageBox
    Vue.prototype.$confirm = MessageBox.confirm
  }
}
export default element



// WEBPACK FOOTER //
// ./src/element/index.js